module.exports = __webpack_public_path__ + "img/wiki2.b4d66a6f.png";